import React, { useEffect, useState } from "react";
import BreadCrumb from "common/breadcrumb";

import Tab from "common/components/tab/tab";
import { Nav } from "common/components/tab/nav";

import UserInvitationComponent from "./cmp-user-invitation";
import TenantInforComponent from "./cmp-tenant-info";
import { Tenant } from "models/tenant/tenant";
import { BrandingData } from "admin-portal/settings/branding";
import { useLocation } from "react-router-dom";
import { GetTenantDetails } from "api/tenant";
import { RoutePath } from "routes/route-path";

const TenantOnboardPage = () => {
  const [tenant, setTenant] = useState<Tenant>();
  const ontenantSave = (tnt: Tenant) => {
    setTenant({ ...tnt });
  };

  // Retrieve query parameters
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const tenantId = searchParams.get("id");

  useEffect(() => {
    if ((tenantId ?? "").length > 0) {
      loadTenant(tenantId!);
    }
  }, [tenantId]);

  const loadTenant = async (tenantId: string) => {
    //setLoading(true);
    const res = await GetTenantDetails(tenantId);
    if (!(res?.status?.isError ?? false) && res?.data) {
      setTenant({ ...(res?.data ?? {}) });
      // setTotal(res?.totalResultCount ?? 0);
    } else {
      // setData([]);
      // setTotal(0);
      console.log("no tenant found");
    }
    // setLoading(false);
  };

  return (
    <React.Fragment>
      <BreadCrumb
        title={"Onboard " + BrandingData.bussinessDomain}
        pageTitle={BrandingData.bussinessDomain + " Manage"}
      />
      <div className="grid grid-cols-1 xl:grid-cols-12 gap-x-5">
        <div className="xl:col-span-12">
          <div className="card">
            <div className="card-body">
              <Tab.Container defaultActiveKey="tab-general">
                <Nav className="flex flex-wrap w-full text-sm font-medium text-center border-b border-slate-200 dark:border-zink-500 nav-tabs">
                  <Nav.Item eventKey="tab-general" className="group">
                    <a
                      /*  href={`#${RoutePath.Admin_TenantOnboard}`} */
                      data-tab-toggle
                      data-target="tab-general"
                      className="inline-block px-4 py-2 text-base transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border-b border-transparent group-[.active]:text-custom-500 group-[.active]:border-b-custom-500 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 dark:group-[.active]:hover:text-custom-500 -mb-[1px]"
                    >
                      General
                    </a>
                  </Nav.Item>
                  <Nav.Item eventKey="tab-user-invite" className="group">
                    <a
                      /*   href={`#${RoutePath.Admin_TenantOnboard}`} */
                      data-tab-toggle
                      data-target="tab-user-invite"
                      className="inline-block px-4 py-2 text-base transition-all duration-300 ease-linear rounded-t-md text-slate-500 dark:text-zink-200 border-b border-transparent group-[.active]:text-custom-500 group-[.active]:border-b-custom-500 hover:text-custom-500 active:text-custom-500 dark:hover:text-custom-500 dark:active:text-custom-500 dark:group-[.active]:hover:text-custom-500 -mb-[1px]"
                    >
                      Invite a User
                    </a>
                  </Nav.Item>
                </Nav>

                <Tab.Content className="mt-5 tab-content">
                  <Tab.Pane eventKey="tab-general" id="tab-general">
                    <div className="mb-0">
                      <TenantInforComponent tenant={tenant} onTenantSaveSuccess={ontenantSave}></TenantInforComponent>
                    </div>
                  </Tab.Pane>

                  <Tab.Pane eventKey="tab-user-invite" id="tab-user-invite">
                    <div className="mb-0">
                      <UserInvitationComponent tenant={tenant}></UserInvitationComponent>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </div>
        </div>
        {/*  <div className="xl:col-span-3">
          <div className="card">
            <div className="card-body">
              <h6 className="mb-4 text-15">Invite a user</h6>
              <div className="mx-auto md:max-w-lg">
              
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </React.Fragment>
  );
};

export default TenantOnboardPage;
